<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="viewBox">
    <g :fill="iconColor" fill-rule="nonzero">
      <path
        d="M11.272 42C5.103 41.964 0 29.332 0 22.899c0-10.51 7.86-12.81 10.888-12.81 1.365 0 2.823.538 4.108 1.014.9.332 1.83.674 2.346.674.31 0 1.04-.291 1.683-.547 1.373-.548 3.082-1.23 5.072-1.23h.012c1.486 0 5.992.327 8.7 4.407l.635.957-.913.691c-1.305.987-3.685 2.788-3.685 6.356 0 4.225 2.696 5.85 3.99 6.632.572.345 1.164.7 1.164 1.479 0 .508-4.042 11.415-9.911 11.415-1.436 0-2.451-.433-3.347-.815-.906-.387-1.687-.72-2.979-.72-.655 0-1.482.31-2.359.64-1.197.449-2.553.958-4.091.958h-.04z"
      />
      <path d="M24.996 0c.157 6.053-3.89 10.252-7.933 9.988C16.397 5.158 21.105 0 24.996 0z" />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'icon-app-store',
    props: {
      width: {
        type: [Number, String],
        default: 34
      },
      height: {
        type: [Number, String],
        default: 42
      },
      viewBox: {
        type: String,
        default: '0 0 34 42'
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
